































































































import { DateRange, EventInfo, EventExtraInfo } from 'inscreva-sse-models';
import moment from 'moment';
import DatePicker from 'ss-commons-front/src/components/DatePicker.vue';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { EventDateHelper } from '../services/EventDateHelper';
import DateRangeList from './DateRangeList.vue';
import DateRangePicker from './DateRangePicker.vue';
import Timelines from './Timelines.vue';

@Component({
  components: {
    Timelines,
    DatePicker,
    DateRangePicker,
    DateRangeList,
  },
})
export default class EventTimelineComponent extends Vue {
  @Prop({ required: true, type: EventInfo })
  private info!: EventInfo;

  @Prop()
  private parentInfo?: EventExtraInfo & EventInfo;

  private isEventOnMultipleDates: boolean = null;

  private disableDateInput: boolean = null;

  $refs!: {
    checkDateTypeProvider: InstanceType<typeof ValidationProvider>;
  };

  mounted() {
    if (this.parentInfo) {
      if (!this.info.dates.length) {
        this.onCreateNewDate();
      }
    } else {
      this.isEventOnMultipleDates = this.info.dates.length && !this.is_event_on_sequence_days;
      if (this.info.dates.length) {
        this.$refs.checkDateTypeProvider.syncValue(true);
      }
    }
  }

  get is_editing_common_date(): boolean {
    return this.common_dates.some((dateRange) => (dateRange as any).hidden === false);
  }

  get is_event_on_sequence_days(): boolean {
    return (
      (this.info.date && EventDateHelper.isSameDay(this.info.date)) ||
      this.info.dates.every(
        (date, index) =>
          index === 0 ||
          moment(new Date(date.start)).date() - moment(new Date(this.info.dates[index - 1].start)).date() === 1,
      )
    );
  }

  get common_dates(): Array<DateRange> {
    return this.info.dates.filter(({ interval }) => !interval);
  }

  get interval_dates(): Array<DateRange> {
    return this.info.dates.filter(({ interval }) => !!interval);
  }

  get allow_interval(): boolean {
    return !!this.parentInfo;
  }

  increaseDay(isoDate: string, quantity: number, dateForHour?: string): string {
    return moment(isoDate)
      .add(quantity, 'days')
      .hours(moment(dateForHour || isoDate).hours())
      .minutes(moment(dateForHour || isoDate).minutes())
      .toISOString();
  }

  onChangeDateRange(multiple: boolean): void {
    this.info.dates = [];
    this.onCreateNewDate();
    this.isEventOnMultipleDates = multiple;
    this.disableDateInput = false;
  }

  onSelectDateRange(): void {
    this.onChangeDateRange(false);
  }

  onSelectMultipleDateRange(): void {
    this.onChangeDateRange(true);
  }

  onChangeDefaultInterval({ checked, dateRange }: { checked: boolean; dateRange: DateRange }): Array<DateRange> {
    if (checked) {
      this.info.dates = [
        {
          start: moment(this.info.date.start)
            .hours(moment(dateRange.start).hours())
            .minutes(moment(dateRange.start).minutes())
            .toISOString(),
          end: moment(this.info.date.end)
            .hours(moment(dateRange.end).hours())
            .minutes(moment(dateRange.end).minutes())
            .toISOString(),
          hidden: false,
        } as DateRange,
      ];
      this.disableDateInput = false;
      return this.onUpdateDates();
    }
    const daysQuantity: number = moment(dateRange.end).diff(dateRange.start, 'days') + 1;
    this.info.dates = new Array(daysQuantity).fill(null).map((d, index) => ({
      start: this.increaseDay(dateRange.start, index),
      end: this.increaseDay(dateRange.start, index, dateRange.end),
      hidden: false,
    }));
    this.disableDateInput = true;
    return this.onUpdateDates();
  }

  get last_date(): DateRange {
    return new Array<DateRange>()
      .concat(this.info.dates)
      .sort(({ end: endA }, { end: endB }) => new Date(endA).getTime() - new Date(endB).getTime())
      .pop();
  }

  onCreateNewDate(interval?: boolean): Array<DateRange> {
    this.info.dates.forEach((date) => ((date as any).hidden = undefined));
    const last_date_end = moment(this.last_date?.end || null);
    this.info.dates.push({
      start: (interval ? moment(last_date_end).add(1, 'minutes') : moment(last_date_end).add(1, 'days')).toISOString(),
      end: (interval ? moment(last_date_end).add(1, 'minutes') : moment(last_date_end).add(1, 'days')).toISOString(),
      hidden: false,
      name: null,
      interval,
    } as DateRange);
    return this.onUpdateDates();
  }

  onAddInterval() {
    return this.onCreateNewDate(true);
  }

  onUpdateCommonDates(dates: Array<DateRange>) {
    this.info.dates = dates.concat(this.interval_dates);
    return this.onUpdateDates();
  }

  onUpdateIntervalDates(dates: Array<DateRange>) {
    this.info.dates = dates.concat(this.common_dates);
    return this.onUpdateDates();
  }

  @Emit()
  onUpdateDates() {
    if (this.info.dates.length === 1 && !this.info.dates[0].interval) {
      this.disableDateInput = false;
    }
    return this.info.dates;
  }
}
